import { render, staticRenderFns } from "./SPetshopAnimal.vue?vue&type=template&id=16af067d"
import script from "./SPetshopAnimal.vue?vue&type=script&lang=js"
export * from "./SPetshopAnimal.vue?vue&type=script&lang=js"
import style0 from "./SPetshopAnimal.vue?vue&type=style&index=0&id=16af067d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports